import {Component} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {UserService} from "../../../../@shared/services/user.service";
import {SnackBarService} from "../../../../@core/services/snack-bar.service";
import {environment} from "../../../../../environments/environment";
import {WalletTypesService} from "../../../../@core/services/wallet-types.service";
import {Observable} from "rxjs";
import {IWalletTypeInfo} from "../../../../@core/interfaces/wallet-type-info.interface";

@Component({
  selector: 'app-add-balance',
  templateUrl: './add-balance.component.html',
  styleUrls: ['./add-balance.component.scss']
})
export class AddBalanceComponent {
  public isGoFast: boolean = environment.projectName === 'CSGOFAST';

  public walletTypes$: Observable<IWalletTypeInfo[]> = this.walletTypesService.getAll();

  public addBalanceForm: UntypedFormGroup = this.fb.group({
    'amount': ['', [Validators.required, Validators.max(1000000)]],
    'comment': ['', Validators.required],
    'type': ['', [Validators.required]]
  });

  constructor(public dialogRef: MatDialogRef<AddBalanceComponent>,
              private readonly fb: UntypedFormBuilder,
              private userService: UserService,
              private walletTypesService: WalletTypesService,
              private sb: SnackBarService) {
  }

  public onSubmit(): void {
    const {amount, comment, type} = this.addBalanceForm.value;

    const body = {
      amount,
      comment,
      type
    }

    this.userService.addMoney(body)
      .subscribe((response) => {
          if (response.success) {
            this.sb.openSnackBar(`Баланс изменен на $${amount / 100}`, 3000, 'success')
            this.dialogRef.close()
          }
          if (!response.success) {
            this.sb.openSnackBar(`Error`, 3000, 'error');
          }
        }
      )


    // if (type === 'REAL') {
    //   this.userService.addMoney(amount, comment).subscribe(
    //     (response) => {
    //       if (response.success) {
    //         this.sb.openSnackBar(`Баланс изменен на $${amount / 100}`, 3000, 'success')
    //         this.dialogRef.close()
    //       }
    //     }
    //   )
    // } else {
    //   this.userService.addDemoMoney(amount, comment).subscribe(
    //     (response) => {
    //       if (response.success) {
    //         this.sb.openSnackBar(`DEMO баланс изменен на $${amount / 100}`, 3000, 'success')
    //         this.dialogRef.close()
    //       }
    //     }
    //   )
    // }
  }

  get amount() {
    return this.addBalanceForm.get('amount');
  }

  close() {
    this.dialogRef.close();
  }

}
